import React, { } from "react"
import { useTranslation } from "react-i18next"
import Stack from '@mui/material/Stack'
import { Container } from '@mui/system'
import { Box, Typography } from '@mui/material'
import { useFaqs } from "../hooks/useFaqs"
import { Titulo } from "../components/commons/Titulo"
import Link from '@mui/material/Link'
import Parser from 'html-react-parser'
import { useTools } from '../hooks/useTools'
import ButtonScrollToTop from '../components/commons/ButtonScrollToTop'
import { AutocompleteSearch } from '../components/commons/AutocompleteSearch'

export function Faqs() {
    const { t } = useTranslation()
    const { listaFaqs } = useFaqs()
    const { scrollToElement, quitarCaracteresExtrañosId } = useTools()

    //TODO pasar funcion scrool al hook para que tenga ahi toda la logica
    const scroll = (value) => {
        if (value) {
            scrollToElement("#" + quitarCaracteresExtrañosId(value.pregunta))
        }
    };


    return (
        <>
            <ButtonScrollToTop />
            {/* <Titulo titulo={t("Glosario.titulo")} size={"2.5em"} /> */}
            {listaFaqs && (
                <Stack marginBottom={5}>
                    <Typography variant='h1'>
                        {t("Faqs.titulo")}
                    </Typography>
                    <AutocompleteSearch dataList={listaFaqs} optionLabel={lt => lt.pregunta} labelText={t("Faqs.buscarPregunta")} onChangeHanddle={scroll} disabled={false} />
                    {(listaFaqs.map((faq, index) =>
                        <Stack marginTop={2} id={quitarCaracteresExtrañosId(faq.pregunta)} key={index}>
                            <Typography
                                variant="h2"
                            >
                                {faq.pregunta}
                            </Typography>
                            <Box maxWidth={{ xs: "90vw", md: "auto" }} style={{ wordWrap: "break-word" }}>
                                <Typography
                                    variant="parrafo"
                                    component="div"
                                    sx={{
                                        marginTop: "1em",
                                        textAlign: "justify"
                                    }}
                                >
                                    {Parser(faq.respuesta)}
                                </Typography>
                            </Box>
                        </Stack>
                    ))}
                </Stack>
            )}
        </>
    )
}
